<template>
  <div id="app">
    <div id="background" :style="background_style"></div>
    <div id="dashboard" class="animated slideInUp" 
      @mouseover="dashboard_hover = true" 
      @mouseout="dashboard_hover = false" 
      :style="dashboard_style + dashboard_style_active">
      <nav v-if="show_nav">
        <div class="left_nav">
          <Fab
            v-if="show_dashboard && show_back_button"
            icon="arrow-left"
            @click.native="back"
            class="animated fadeInLeft"
            :color="vibrant_lightcolor"
            :small="true"
            style="margin-right: 20px;"
          />
        </div>
        <div class="middle_nav">
          <a href="#dashboard" @click="toggleDashboard" v-smooth-scroll>
            <Fab :icon="loading_dashboard ? 'spinner fa-spin' : !show_dashboard ? 'chevron-up' : 'chevron-down'" :color="vibrant_lightcolor" class="animated fadeInDown" />
          </a>
        </div>
        <div class="right_nav">
          <!--<Fab icon="user-circle" :color="vibrant_lightcolor" class="animated fadeInRight" />-->
        </div>
      </nav>
      <nav v-if="!show_nav" style="height: 60px;"></nav>
      <transition name="slide">
        <div v-if="!first_show_dashboard" v-show="show_dashboard">
          <transition name="fade">
            <router-view style="min-height:74vh;" />
          </transition>
        </div>
      </transition>
      <div class="attribution" :style="{paddingLeft: '30px', color: vibrant_lightcolor }">
        <div class="left_nav" style="width:50%;">
          <transition name="fade">
            <p v-show="!show_dashboard">
              <a :href="attribution.links.html" :style="{color: this.vibrant_lightcolor}" target="_blank">{{ attribution.location.title }}</a> {{ attribution.location.title === null ? '' : '(' }}<a :href="attribution.user.links.html" :style="{color: this.vibrant_lightcolor}" target="_blank">Photo by {{ attribution.user.name }} on Unsplash</a>{{ attribution.location.title === null ? '' : ')' }}
            </p>
          </transition>
        </div>
        <div class="right_nav" style="width:50%;">
          <Fab
            icon="cog"
            @click.native="goToSettings"
            class="animated fadeInRight"
            :color="vibrant_lightcolor"
            :small="true"
            v-show="show_dashboard"
            style="margin-right: 20px;float:right;"
            />
          <Fab
            icon="columns"
            @click.native="goToManagement"
            class="animated fadeInRight"
            :color="vibrant_lightcolor"
            :small="true"
            v-show="show_dashboard"
            style="margin-right: 20px;float:right;"
            />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Config from "./config";

import { auth, storage } from "./schmucklicloud";

import * as Vibrant from 'node-vibrant';

export default {
  name: "app",
  data() {
    return {
      show_nav: true,
      show_back_button: false,
      show_dashboard: false,
      dashboard_hover: false,
      first_show_dashboard: true,
      background_style: "",
      dashboard_style: "",
      background_image_color: {
        r: 0,
        g: 0,
        b: 0
      },

      loading_dashboard: false,

      attribution: {}
    };
  },
  mounted() {
    this.checkSession()
    this.initNav();
    this.createBackground();

    window.addEventListener('keydown', this.toggleDashboardByKey);
  },
  computed: {
    dashboard_style_active() {
      return !this.show_dashboard && !this.dashboard_hover ? 'background-color:rgba(' + this.background_image_color.r + ', ' + this.background_image_color.g + ', ' + this.background_image_color.b + ', 0);transition:background-color 0.3s;' : 'background:rgba(' + this.background_image_color.r + ', ' + this.background_image_color.g + ', ' + this.background_image_color.b + ', 0.7);transition: 0.3s;';
    }
  },
  methods: {
    checkSession() {
      //Checks the session on startup.
      var session_token = window.localStorage.getItem("session_token");
      auth.checkSession(session_token).then(function(response) {
        if (!response.isOK) {
          window.localStorage.setItem("session_token", "");
          this.$router.replace("/login");
        }
      }.bind(this));
    },
    initNav() {
      //Start the application with an open dialog
      switch(this.$router.currentRoute.path) {
        case "/activate":
          this.first_show_dashboard = true;
          this.show_dashboard = true;
          break;
      }

      //Show back button
      switch (this.$router.currentRoute.path) {
        case "/":
        case "/login":
        case "/register":
          this.show_back_button = false;
          break;
        default:
          this.show_back_button = true;
          break;
      }
    },
    goToManagement() {
      this.$router.push("/management");
    },
    goToSettings() {
      this.$router.push("/settings");
    },
    toggleDashboard() {
      this.show_dashboard = !this.show_dashboard;
    },
    back() {
      this.$router.go(-1);
    },
    toggleDashboardByKey(e) {
      if(e.keyCode == '38') {
        this.show_dashboard = true;
      } else if (e.keyCode == '40') {
        this.show_dashboard = false;
      }
    },
    async createBackground() {
      var query = "";
      var response_settings = await storage.getAll("settings");
      if (response_settings.isOK) {
        query = response_settings.data ? response_settings.data[0].data.wallpaper_topic : "City Skyline";
      } else {
        query = "City Skyline";
      }

      /*var hour = (new Date()).getHours();
      if (hour > 21 || hour <= 6) {
        query = query + " night";
      } else if (hour <= 11) {
        query = query + " morning";
      } else if (hour <= 17) {
        query = query + " day";
      } else if (hour <= 21) {
        query = query + " evening";
      }*/

      var response = await axios.get(
        "https://api.unsplash.com/photos/random?client_id=" +
          Config.UNSPLASH_CLIENT_ID +
          "&query=" +
          encodeURIComponent(query) +
          "&orientation=landscape"
      );
      if (response.status === 200) {
        var json = response.data;
        this.background_style =
          "background-image:url('" + json.urls.small + "');filter:blur(5px);";

        Vibrant.from(json.urls.small).getPalette(function (err, palette) {
          this.background_image_color = palette.DarkMuted;

          //Setting the color of the dashboard background and general color
          this.dashboard_style =
            "background-color:rgba(" + this.background_image_color.r + "," + this.background_image_color.g + "," + this.background_image_color.b + ", 0.5)" + ";";
          //var light_color = palette.LightMuted;
          this.vibrant_lightcolor = "#ffffff"/*"rgba(" + light_color.r + "," + light_color.g + "," + light_color.b + ", 1)"*/;

          //Change meta theme color
          var metaThemeColor = document.querySelector("meta[name=theme-color]");
          metaThemeColor.setAttribute("content", "rgba(" + this.background_image_color.r + "," + this.background_image_color.g + "," + this.background_image_color.b + ", 1)");
        }.bind(this));

        //Setting the attribution box
        this.attribution = json;

        var image = new Image();
        image.src = json.urls.full;
        var request_image = setInterval(
          function() {
            if (image.complete) {
              clearInterval(request_image);
              this.background_style =
                "background-image:url('" + json.urls.full + "');";
            }
          }.bind(this),
          100
        );
      }
    }
  },
  watch: {
    $route() {
      this.initNav();
    },

    //Detect if the dashboard was opened for the first time.
    show_dashboard(value) {
      if(this.first_show_dashboard) {
        this.show_dashboard = false;
        this.loading_dashboard = true;
        setTimeout(function() {
          this.show_dashboard = true;
          this.loading_dashboard = false;
        }.bind(this), 100);
      }

      if(value) {
        this.first_show_dashboard = false;
      }
    }
  }
};
</script>

<style>
/** External CSS files */
@import "./assets/css/animate.css";
@import "./assets/css/grid12.css";

/** Internal CSS files */
@import "./assets/css/carousel_add.css";
@import "./assets/css/layout.css";
@import "./assets/css/tags_dark.css";

.fade-enter-active {
  transition-duration: 0.8s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-leave-active {
  transition-duration: 0s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
